// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mosque-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M10 5.58569V7.68228C11.0749 6.06551 12.913 4.9999 15 4.9999C17.973 4.9999 20.4409 7.16219 20.917 9.9999H22V21.9999H2V5.58569L6 1.58569L10 5.58569Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M13 15V21H17V15H13Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6.00391 9V9.00391H6M13 21V15H17V21H13Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 21H3V6L6 3L9 6V11M9 21V11M9 21H21V11H20M9 11H10M10 11H20M10 11C10 8.23858 12.2386 6 15 6M20 11C20 8.23858 17.7614 6 15 6M15 6V4.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-mosque-1')
export default class Mosque1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mosque-1',
    }
  }
}
